import { cn } from '../../utils/cn';

export default function Select({ label, options = [], className, ...props }) {
  return (
    <div className="space-y-1.5">
      {label && <label className="block text-xs font-semibold text-navy-500 uppercase tracking-wider">{label}</label>}
      <div className="relative">
        <select
          className={cn(
            'w-full appearance-none rounded-xl border border-surface-300 bg-white px-4 py-2.5 pr-10 text-sm text-navy-800',
            'transition-all duration-200 focus-ring hover:border-surface-400',
            className,
          )}
          {...props}
        >
          {options.map((o) =>
            typeof o === 'string' ? (
              <option key={o} value={o}>{o}</option>
            ) : (
              <option key={o.value} value={o.value}>{o.label}</option>
            ),
          )}
        </select>
        <div className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-navy-400">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </div>
  );
}
